import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaTicketAlt, FaShoppingBag, FaCalendarAlt, FaHistory } from 'react-icons/fa';
import GlobalHeader from '../../../../components/GlobalHeader.jsx';
import '../css/CustomerDashboard.css';

const CustomerDashboard = () => {
  const nav = useNavigate();

  return (
    <div className="customer-dashboard">
      <GlobalHeader
        title="Customer Dashboard"
        subtitle="Manage your events and tickets"
        backTo="/mainmenu"
        logoutTo="/"
      />

      {/* Main Content */}
      <div className="content-wrapper">
        <div className="user-options">
          <div 
            className="option-card-base book-events-card"
            onClick={() => nav("/eventmenu")}
          >
            <div className="card-icon">
              <FaTicketAlt />
            </div>
            <div className="option-content">
              <h2 className="card-title">Book Events</h2>
              <p className="card-desc">Browse and book event tickets</p>
              <ul className="feature-list">
                <li className="feature-item"><FaCalendarAlt style={{color: 'black'}} /> Browse upcoming events</li>
                <li className="feature-item"><FaTicketAlt style={{color: 'black'}} /> Purchase tickets securely</li>
              </ul>
              <button className="enter-button-base">Enter</button>
            </div>
          </div>
          
          <div 
            className="option-card-base my-purchases-card"
            onClick={() => nav("/reviewpurchase")}
          >
            <div className="card-icon purchases-icon">
              <FaShoppingBag />
            </div>
            <div className="option-content">
              <h2 className="card-title">My Purchases</h2>
              <p className="card-desc">View your ticket purchases</p>
              <ul className="feature-list">
                <li className="feature-item"><FaHistory style={{color: 'black'}} /> View purchase history</li>
                <li className="feature-item"><FaTicketAlt style={{color: 'black'}} /> Manage your tickets</li>
              </ul>
              <button className="enter-button-base purchases-button">Enter</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerDashboard;
